import { render, staticRenderFns } from "./bm-quote-builder-view.vue?vue&type=template&id=4cb5679c&"
import script from "./bm-quote-builder-view.vue?vue&type=script&lang=js&"
export * from "./bm-quote-builder-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports